import { __decorate } from "tslib";
import { Message, MessageParamDefinition, MessageType } from 'ircv3';
// this command has no *useful* parameters, all information is in tags
/** @private */
let HostTarget = class HostTarget extends Message {
};
__decorate([
    MessageParamDefinition({
        type: 'channel'
    })
], HostTarget.prototype, "channel", void 0);
__decorate([
    MessageParamDefinition({
        trailing: true
    })
], HostTarget.prototype, "targetAndViewers", void 0);
HostTarget = __decorate([
    MessageType('HOSTTARGET')
], HostTarget);
export { HostTarget };
